<template>
  <div class="bg-primary-darker py-14 hidden md:flex flex-col items-center">
    <div class="container">
      <div class="flex flex-wrap" style="margin: 0">
        <div
          class="w-full p-3 justify-center align-middle flex-1 flex flex-col"
        >
          <div class="flex align-middle justify-center pb-3 text-5xl">
            <IconComponent class="text-white" icon="briefcase" />
          </div>
          <div class="flex align-middle justify-center text-white text-2xl">
            {{
              $t("professionTaskLinks.title", {
                profession: $helpers.capitalize(profession.name),
              })
            }}
          </div>
        </div>

        <section class="flex-1 p-3">
          <div class="text-2xl text-primary-lightest text-center pb-8">
            {{ $t("professionTaskLinks.popularProfessionTasks") }}
          </div>
          <div class="grid pl-5">
            <NuxtLink
              v-for="professionTask in popularProfessionTasks"
              :key="`plp${professionTask.id}`"
              class="text-white hover:text-primary-lighter mr-auto upper-case-first"
              :to="
                localePath({
                  name: 'prices',
                  params: { professionTask: professionTask.seoName },
                })
              "
              @click.native="onClickProfessionTask(professionTask)"
            >
              {{
                $t("professionTaskLinks.priceLink", {
                  professionTask: professionTask.name,
                })
              }}
            </NuxtLink>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    profession: {
      type: Object,
      required: true,
    },
    popularProfessionTasks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClickProfessionTask(professionTask) {
      this.$trackers.trackEvent({
        title: "Clicked Profession Task Link on Footer",
        data: {
          professionTaskSeoName: professionTask.seoName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-columns: repeat(auto-fill, auto);
  gap: 8px 24px;
}

.upper-case-first::first-letter {
  text-transform: uppercase;
}
</style>
